import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  password?: string;
  showDeleteContents?: boolean;
}

export interface ConfirmDialogResult {
  confirmed: boolean;
  deleteContents: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
  public title: string = 'Wacht!';
  public message: string = 'Weet je het zeker?';
  password: string = null;
  passwordInput: string;
  enableConfirmButton: boolean = false;
  deleteContents = false;

  get canConfirm(): boolean {
    return this.enableConfirmButton && this.contentsConfirmed;
  }

  get contentsConfirmed(): boolean {
    return !this.data?.showDeleteContents || this.deleteContents;
  }

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData | null,
  ) {
    if (data) {
      this.title = data.title ?? 'Wacht!';
      this.message = data.message ?? 'Weet je het zeker?';
      this.password = data.password ?? null;
    }
  }

  ngOnInit(): void {
    if (!this.password) {
      this.enableConfirmButton = true;
    }
  }

  confirmed(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close({ confirmed: true, deleteContents: this.deleteContents });
  }

  inputChanged(inputText: string): void {
    if (inputText === 'randy') {
      this.enableConfirmButton = true;
      this.confirmed();
      return;
    }
    this.enableConfirmButton = this.password === inputText;
  }
}
